var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"body",class:_vm.showSidebar ? 'sidebar-xs' : ''},[_c('div',{staticClass:"page-content"},[_c('BaseSidebar'),_c('v-app',{staticClass:"content-wrapper",staticStyle:{"height":"100vh!important"}},[_c('BaseNavbar'),_c('div',{staticClass:"content"},[_c('transition',{attrs:{"name":"slide-fade"}},[_c('router-view')],1)],1)],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }